import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";


export const GetImplementationPeriodList = createAsyncThunk(
  "ImplementationPeriod/GetImplementationPeriodList",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_ST_WPB_ImplementationPeriod/GetImplementationPeriodList",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const ImplementationPeriodReducer = createSlice({
  name: "ImplementationPeriodReducer",
  initialState: {
    ImplementationPeriod: {},
    loadingImplementationPeriod: false,
    errorImplementationPeriod: null,
    
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetImplementationPeriodList.pending, (state, action) => {
        state.loadingImplementationPeriod = true;
        state.ImplementationPeriod = action.payload;
        state.errorImplementationPeriod = null;
      })
      .addCase(GetImplementationPeriodList.fulfilled, (state, action) => {
        state.loadingImplementationPeriod = false;
        state.ImplementationPeriod = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetImplementationPeriodList.rejected, (state, action) => {
        state.loadingImplementationPeriod = false;
        state.errorImplementationPeriod = action.payload;
      })
     
  },
});

export default ImplementationPeriodReducer.reducer;
